
const surveyStore = {
	namespaced: true,
	state: {
		currentSurvey: null
	},
	mutations: {
		setSurvey (state, sv) {
			state.currentSurvey = sv
		}
	}
}

export default surveyStore


// WEBPACK FOOTER //
// ./src/store/modules/survey.js